export const judgeMe = () => {
    const ratingsCarousels = document.querySelectorAll('.jdgm-all-reviews-rating-wrapper');

    if (!ratingsCarousels) {
        return;
    }

    ratingsCarousels.forEach(function (jmDate) {
        jmDate.innerHTML = jmDate.innerHTML.replace('from', 'Remiantis');
        jmDate.innerHTML = jmDate.innerHTML.replace(' reviews', ' atsiliepimais');
    });
};
